import React from 'react';
import { Flex } from 'antd';

import { ChatListContainer } from 'features/analytics/features/ChatList/containers/ChatListContainer';

import { PostsContainer } from './containers/PostsContainer';
import { PostsSimpleLineChart } from './components/PostsSimpleLineChart';
import { PostsChart } from './components/PostsChart';
import { useAppSelector } from '../../../../store';
import { MessagesChart } from '../AnalyticMessages/components/MessagesChart';
import { MessageTopicsChart } from '../AnalyticMessages/components/MessageTopicsChart';
import { MessagesMultiLineChart } from '../AnalyticMessages/components/MessagesMultiLineChart';
import { ActiveMembersChart } from '../AnalyticMembers/components/ActiveMembersChart';
import { selectAnalyticsFilters } from '../../store/analyticFiltersSlice';

export const AnalyticPosts = () => {
    const { chat } = useAppSelector(selectAnalyticsFilters);

    return (
        <Flex gap={16}>
            {!chat && (
                <Flex gap={16} vertical>
                    <Flex gap={16} wrap={'wrap'} justify={'space-between'}>
                        <MessagesChart />
                        {chat && <MessageTopicsChart />}
                    </Flex>

                    <Flex gap={16}>
                        <Flex flex={2}>
                            <MessagesMultiLineChart />
                        </Flex>
                        <Flex flex={1}>
                            <ActiveMembersChart />
                        </Flex>
                    </Flex>

                    <ChatListContainer />
                </Flex>
            )}
            {chat && (
                <Flex gap={16} vertical style={{ width: '100%' }}>
                    <Flex gap={16} vertical={false}>
                        <Flex flex={1}>
                            <PostsSimpleLineChart />
                        </Flex>
                        <Flex flex={1}>
                            <PostsChart />
                        </Flex>
                    </Flex>
                    <PostsContainer />
                </Flex>
            )}
        </Flex>
    );
};
